import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../wayfinder'
/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
const loginForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::login
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:47
* @route '/login'
*/
loginForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: login.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

login.form = loginForm

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
const logoutForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

/**
* @see \Laravel\Fortify\Http\Controllers\AuthenticatedSessionController::logout
* @see vendor/laravel/fortify/src/Http/Controllers/AuthenticatedSessionController.php:100
* @route '/logout'
*/
logoutForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: logout.url(options),
    method: 'post',
})

logout.form = logoutForm

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
const registerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url(options),
    method: 'get',
})

/**
* @see \Laravel\Fortify\Http\Controllers\RegisteredUserController::register
* @see vendor/laravel/fortify/src/Http/Controllers/RegisteredUserController.php:41
* @route '/register'
*/
registerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: register.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

register.form = registerForm

/**
* @see routes/web.php:21
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:21
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see routes/web.php:21
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:21
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see routes/web.php:21
* @route '/'
*/
const homeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:21
* @route '/'
*/
homeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:21
* @route '/'
*/
homeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: home.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

home.form = homeForm

/**
* @see routes/web.php:41
* @route '/dashboard'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/dashboard',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:41
* @route '/dashboard'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see routes/web.php:41
* @route '/dashboard'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see routes/web.php:41
* @route '/dashboard'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see routes/web.php:41
* @route '/dashboard'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see routes/web.php:41
* @route '/dashboard'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see routes/web.php:41
* @route '/dashboard'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\GuessProductTypeController::guessProductType
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/GuessProductTypeController.php:19
* @route '/guess-product-type'
*/
export const guessProductType = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: guessProductType.url(options),
    method: 'post',
})

guessProductType.definition = {
    methods: ["post","options"],
    url: '/guess-product-type',
} satisfies RouteDefinition<["post","options"]>

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\GuessProductTypeController::guessProductType
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/GuessProductTypeController.php:19
* @route '/guess-product-type'
*/
guessProductType.url = (options?: RouteQueryOptions) => {
    return guessProductType.definition.url + queryParams(options)
}

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\GuessProductTypeController::guessProductType
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/GuessProductTypeController.php:19
* @route '/guess-product-type'
*/
guessProductType.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: guessProductType.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\GuessProductTypeController::guessProductType
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/GuessProductTypeController.php:19
* @route '/guess-product-type'
*/
guessProductType.options = (options?: RouteQueryOptions): RouteDefinition<'options'> => ({
    url: guessProductType.url(options),
    method: 'options',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\GuessProductTypeController::guessProductType
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/GuessProductTypeController.php:19
* @route '/guess-product-type'
*/
const guessProductTypeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: guessProductType.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\GuessProductTypeController::guessProductType
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/GuessProductTypeController.php:19
* @route '/guess-product-type'
*/
guessProductTypeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: guessProductType.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\GuessProductTypeController::guessProductType
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/GuessProductTypeController.php:19
* @route '/guess-product-type'
*/
guessProductTypeForm.options = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: guessProductType.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'OPTIONS',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

guessProductType.form = guessProductTypeForm

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\FetchProductTypeCategoriesController::fetchProductTypeCategories
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/FetchProductTypeCategoriesController.php:18
* @route '/fetch-product-type-categories'
*/
export const fetchProductTypeCategories = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: fetchProductTypeCategories.url(options),
    method: 'post',
})

fetchProductTypeCategories.definition = {
    methods: ["post","options"],
    url: '/fetch-product-type-categories',
} satisfies RouteDefinition<["post","options"]>

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\FetchProductTypeCategoriesController::fetchProductTypeCategories
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/FetchProductTypeCategoriesController.php:18
* @route '/fetch-product-type-categories'
*/
fetchProductTypeCategories.url = (options?: RouteQueryOptions) => {
    return fetchProductTypeCategories.definition.url + queryParams(options)
}

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\FetchProductTypeCategoriesController::fetchProductTypeCategories
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/FetchProductTypeCategoriesController.php:18
* @route '/fetch-product-type-categories'
*/
fetchProductTypeCategories.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: fetchProductTypeCategories.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\FetchProductTypeCategoriesController::fetchProductTypeCategories
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/FetchProductTypeCategoriesController.php:18
* @route '/fetch-product-type-categories'
*/
fetchProductTypeCategories.options = (options?: RouteQueryOptions): RouteDefinition<'options'> => ({
    url: fetchProductTypeCategories.url(options),
    method: 'options',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\FetchProductTypeCategoriesController::fetchProductTypeCategories
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/FetchProductTypeCategoriesController.php:18
* @route '/fetch-product-type-categories'
*/
const fetchProductTypeCategoriesForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: fetchProductTypeCategories.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\FetchProductTypeCategoriesController::fetchProductTypeCategories
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/FetchProductTypeCategoriesController.php:18
* @route '/fetch-product-type-categories'
*/
fetchProductTypeCategoriesForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: fetchProductTypeCategories.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\FetchProductTypeCategoriesController::fetchProductTypeCategories
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/FetchProductTypeCategoriesController.php:18
* @route '/fetch-product-type-categories'
*/
fetchProductTypeCategoriesForm.options = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fetchProductTypeCategories.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'OPTIONS',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

fetchProductTypeCategories.form = fetchProductTypeCategoriesForm

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\LoadProductTypeAttributesController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/LoadProductTypeAttributesController.php:24
* @route '/fetch-product-type-attributes'
*/
export const fetchProductTypeAttributes = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: fetchProductTypeAttributes.url(options),
    method: 'post',
})

fetchProductTypeAttributes.definition = {
    methods: ["post","options"],
    url: '/fetch-product-type-attributes',
} satisfies RouteDefinition<["post","options"]>

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\LoadProductTypeAttributesController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/LoadProductTypeAttributesController.php:24
* @route '/fetch-product-type-attributes'
*/
fetchProductTypeAttributes.url = (options?: RouteQueryOptions) => {
    return fetchProductTypeAttributes.definition.url + queryParams(options)
}

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\LoadProductTypeAttributesController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/LoadProductTypeAttributesController.php:24
* @route '/fetch-product-type-attributes'
*/
fetchProductTypeAttributes.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: fetchProductTypeAttributes.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\LoadProductTypeAttributesController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/LoadProductTypeAttributesController.php:24
* @route '/fetch-product-type-attributes'
*/
fetchProductTypeAttributes.options = (options?: RouteQueryOptions): RouteDefinition<'options'> => ({
    url: fetchProductTypeAttributes.url(options),
    method: 'options',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\LoadProductTypeAttributesController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/LoadProductTypeAttributesController.php:24
* @route '/fetch-product-type-attributes'
*/
const fetchProductTypeAttributesForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: fetchProductTypeAttributes.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\LoadProductTypeAttributesController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/LoadProductTypeAttributesController.php:24
* @route '/fetch-product-type-attributes'
*/
fetchProductTypeAttributesForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: fetchProductTypeAttributes.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\LoadProductTypeAttributesController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/LoadProductTypeAttributesController.php:24
* @route '/fetch-product-type-attributes'
*/
fetchProductTypeAttributesForm.options = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fetchProductTypeAttributes.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'OPTIONS',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

fetchProductTypeAttributes.form = fetchProductTypeAttributesForm

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\ResolveConditionalRequirementsController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/ResolveConditionalRequirementsController.php:22
* @route '/resolve-conditional-requirements'
*/
export const resolveConditionalRequirements = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolveConditionalRequirements.url(options),
    method: 'post',
})

resolveConditionalRequirements.definition = {
    methods: ["post","options"],
    url: '/resolve-conditional-requirements',
} satisfies RouteDefinition<["post","options"]>

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\ResolveConditionalRequirementsController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/ResolveConditionalRequirementsController.php:22
* @route '/resolve-conditional-requirements'
*/
resolveConditionalRequirements.url = (options?: RouteQueryOptions) => {
    return resolveConditionalRequirements.definition.url + queryParams(options)
}

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\ResolveConditionalRequirementsController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/ResolveConditionalRequirementsController.php:22
* @route '/resolve-conditional-requirements'
*/
resolveConditionalRequirements.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolveConditionalRequirements.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\ResolveConditionalRequirementsController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/ResolveConditionalRequirementsController.php:22
* @route '/resolve-conditional-requirements'
*/
resolveConditionalRequirements.options = (options?: RouteQueryOptions): RouteDefinition<'options'> => ({
    url: resolveConditionalRequirements.url(options),
    method: 'options',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\ResolveConditionalRequirementsController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/ResolveConditionalRequirementsController.php:22
* @route '/resolve-conditional-requirements'
*/
const resolveConditionalRequirementsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolveConditionalRequirements.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\ResolveConditionalRequirementsController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/ResolveConditionalRequirementsController.php:22
* @route '/resolve-conditional-requirements'
*/
resolveConditionalRequirementsForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolveConditionalRequirements.url(options),
    method: 'post',
})

/**
* @see \App\Modules\Catalog\Http\Controllers\ProductCreation\Api\ResolveConditionalRequirementsController::__invoke
* @see app/Modules/Catalog/Http/Controllers/ProductCreation/Api/ResolveConditionalRequirementsController.php:22
* @route '/resolve-conditional-requirements'
*/
resolveConditionalRequirementsForm.options = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: resolveConditionalRequirements.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'OPTIONS',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

resolveConditionalRequirements.form = resolveConditionalRequirementsForm

/**
* @see \App\Modules\Payments\Http\Controllers\PaymentSetupController::payment
* @see app/Modules/Payments/Http/Controllers/PaymentSetupController.php:20
* @route '/payment'
*/
export const payment = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payment.url(options),
    method: 'get',
})

payment.definition = {
    methods: ["get","head"],
    url: '/payment',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Modules\Payments\Http\Controllers\PaymentSetupController::payment
* @see app/Modules/Payments/Http/Controllers/PaymentSetupController.php:20
* @route '/payment'
*/
payment.url = (options?: RouteQueryOptions) => {
    return payment.definition.url + queryParams(options)
}

/**
* @see \App\Modules\Payments\Http\Controllers\PaymentSetupController::payment
* @see app/Modules/Payments/Http/Controllers/PaymentSetupController.php:20
* @route '/payment'
*/
payment.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payment.url(options),
    method: 'get',
})

/**
* @see \App\Modules\Payments\Http\Controllers\PaymentSetupController::payment
* @see app/Modules/Payments/Http/Controllers/PaymentSetupController.php:20
* @route '/payment'
*/
payment.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: payment.url(options),
    method: 'head',
})

/**
* @see \App\Modules\Payments\Http\Controllers\PaymentSetupController::payment
* @see app/Modules/Payments/Http/Controllers/PaymentSetupController.php:20
* @route '/payment'
*/
const paymentForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payment.url(options),
    method: 'get',
})

/**
* @see \App\Modules\Payments\Http\Controllers\PaymentSetupController::payment
* @see app/Modules/Payments/Http/Controllers/PaymentSetupController.php:20
* @route '/payment'
*/
paymentForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payment.url(options),
    method: 'get',
})

/**
* @see \App\Modules\Payments\Http\Controllers\PaymentSetupController::payment
* @see app/Modules/Payments/Http/Controllers/PaymentSetupController.php:20
* @route '/payment'
*/
paymentForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payment.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

payment.form = paymentForm
